import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import kebabCase from 'lodash/kebabCase'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Text from 'components/common/Text/Text'
import { ServiceIcon } from 'components/common/ServiceIcon'
import { dynamicDataAttribute } from 'helpers/utils'
import model from './viewModel'
import ServicesBlock from './ServicesBlock'
import { Field } from 'redux-form'
import ArrowIconFullRedRight from 'components/common/Icon/assets/arrow-icon-full-red-right.svg'
import { LOOKING_FOR_TIRE_PRICES_CATEGORY } from './constants'

const ServiceCategory = ({
  className,
  condition,
  checked,
  title,
  categoryServices,
  chosenIndex,
  index,
  iconName,
  ...props
}) =>
  <Fragment>
    <Wrapper
      { ...dynamicDataAttribute(`category-${kebabCase(title)}`) }
      tabIndex="0"
      type="button"
      className={ className }
      condition={ condition }
      { ...props }>
      <Block>
        <Checked { ...dynamicDataAttribute(`category-${kebabCase(title)}-selected`, checked) } asset="check-circle" hidden={ !checked } />
        <ServiceIcon { ...dynamicDataAttribute(`category-${kebabCase(title)}-icon`) } iconName={ iconName } condition={ condition } small />
      </Block>
      <Service>
        <Title { ...dynamicDataAttribute(`category-${kebabCase(title)}-title`) } condition={ condition } inline follow_link>{ title }</Title>
      </Service>
    </Wrapper>
    <Media.Mobile>
      <Region
        role="region"
        id={ `${kebabCase(title)}-region-${index}` }
        aria-labelledby={ `${kebabCase(title)}-accordion-${index}` }>
        <Field
          { ...model.servicesSelector }
          hidden={ chosenIndex !== index }
          component={ ServicesBlock }
          defaultData={ categoryServices }
          title={ title }
          showLookingForTirePrices={ title === LOOKING_FOR_TIRE_PRICES_CATEGORY } />
      </Region>
    </Media.Mobile>
  </Fragment>

ServiceCategory.propTypes = {
  categoryServices: PropTypes.arrayOf(PropTypes.shape()),
  checked: PropTypes.bool,
  chosenIndex: PropTypes.number,
  className: PropTypes.string,
  condition: PropTypes.bool,
  iconName: PropTypes.string,
  index: PropTypes.number,
  title: PropTypes.string
}

export default ServiceCategory

const Wrapper = styled.button`
  position: relative;
  display: inline-block;
  margin: 0 10px;
  padding: 20px 0;
  text-align: center;
  vertical-align: top;
  background: none;
  border: none;
  cursor: default;
  overflow: visible;
  ${Media.mobile`
    margin: 25px 0 0;
    padding: 10px 0;
    width: 50%;
  `}

  ${props => props.condition && css`
    &::after,
    &::before {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      z-index: 2;
      margin-left: -16px;
      border: 16px solid transparent;
      border-top: 16px solid ${Theme.colors.light_grey};
    }

    &::after {
      margin-left: -15px;
      border-width: 15px;
      border-top-color: ${Theme.colors.white};
    }
  `}
`

const Region = styled.div`
  width: 100%;
  float: left;
`

const Checked = styled(Icon)`
  position: absolute;
  top: -14px;
  ${Mixin.responsive('right', '7px', '-14px')}
`

const Service = styled.div`
  height: 3.2em;
`

const Block = styled.div`
  position: relative;
  margin: 0 0 20px;
  height: 56px;
  ${Mixin.middle()}
  ${Media.mobile`
    display: inline-block;
  `}
`

const Title = styled(Text)`
  width: 8em;
  ${Mixin.font.GothamBold(14, 600)}
  ${props => props.condition && css`
    ::after {
      content: '';
      background-image: url(${ArrowIconFullRedRight});
      display: inline-block;
      background-repeat: no-repeat;
      background-size: contain;
      height: 13px;
      width: 5px;
      margin-left: 5px;
      vertical-align: middle;
    }
  `}
`
